// Generated by clients/ui/scripts/subset-icons.py from clients/ui/icons.txt. Do not edit.
// Phosphor icon name -> codepoint in the bundled subset (@phosphor-icons/web@2.1.1).
export const ICON_GLYPHS: Readonly<Record<string, number>> = {
  "arrow-clockwise": 0xe036,
  "arrow-counter-clockwise": 0xe038,
  "arrow-left": 0xe058,
  "arrow-right": 0xe06c,
  "arrow-square-out": 0xe5de,
  "arrow-up": 0xe08e,
  "arrows-clockwise": 0xe094,
  "arrows-left-right": 0xe0a0,
  "at": 0xe0ac,
  "bell": 0xe0ce,
  "book": 0xe0e2,
  "book-open": 0xe0e6,
  "bookmark-simple": 0xe0ea,
  "browser": 0xe0f4,
  "buildings": 0xe102,
  "calendar-blank": 0xe10a,
  "calendar-x": 0xe10c,
  "camera-rotate": 0xe7a4,
  "caret-down": 0xe136,
  "caret-left": 0xe138,
  "caret-right": 0xe13a,
  "caret-up": 0xe13c,
  "caret-up-down": 0xe140,
  "chart-donut": 0xeaa6,
  "chats": 0xe17c,
  "check": 0xe182,
  "check-circle": 0xe184,
  "circle-notch": 0xeb44,
  "clock": 0xe19a,
  "clock-counter-clockwise": 0xe1a0,
  "closed-captioning": 0xe1a4,
  "cloud-arrow-up": 0xe1ae,
  "cloud-check": 0xe1b0,
  "cloud-slash": 0xe1b6,
  "copy": 0xe1ca,
  "corners-out": 0xe1d0,
  "desktop": 0xe560,
  "dots-three": 0xe1fe,
  "dots-three-vertical": 0xe208,
  "download-simple": 0xe20c,
  "envelope-simple": 0xe218,
  "export": 0xeaf0,
  "eye": 0xe220,
  "eye-slash": 0xe224,
  "file-text": 0xe23a,
  "flag": 0xe244,
  "folder-simple": 0xe25a,
  "folder-user": 0xeb46,
  "gear-six": 0xe272,
  "globe": 0xe288,
  "globe-simple": 0xe28e,
  "google-chrome-logo": 0xe976,
  "grid-four": 0xe296,
  "hourglass": 0xe2b2,
  "hourglass-high": 0xe2b4,
  "house": 0xe2c2,
  "info": 0xe2ce,
  "key": 0xe2d6,
  "lightning": 0xe2de,
  "link-break": 0xe2e4,
  "link-simple": 0xe2e6,
  "list": 0xe2f0,
  "list-bullets": 0xe2f2,
  "lock-simple": 0xe308,
  "magnifying-glass": 0xe30c,
  "megaphone": 0xe324,
  "microphone": 0xe326,
  "microphone-slash": 0xe328,
  "minus": 0xe32a,
  "monitor": 0xe32e,
  "password": 0xe752,
  "pause": 0xe39e,
  "pause-circle": 0xe3a0,
  "pencil-simple": 0xe3b4,
  "picture-in-picture": 0xe64c,
  "play": 0xe3d0,
  "play-circle": 0xe3d2,
  "plus": 0xe3d4,
  "plus-circle": 0xe3d6,
  "question": 0xe3e8,
  "record": 0xe3ee,
  "robot": 0xe762,
  "scissors": 0xeae0,
  "seal-check": 0xe606,
  "selection": 0xe69a,
  "share-network": 0xe408,
  "shield-check": 0xe40c,
  "sign-out": 0xe42a,
  "sliders-horizontal": 0xe434,
  "sparkle": 0xe6a2,
  "speaker-high": 0xe44a,
  "speaker-slash": 0xe45a,
  "stop": 0xe46c,
  "stop-circle": 0xe46e,
  "subtitles": 0xe1a8,
  "timer": 0xe492,
  "trash": 0xe4a6,
  "user": 0xe4c2,
  "user-plus": 0xe4d0,
  "user-sound": 0xeca8,
  "users": 0xe4d6,
  "users-three": 0xe68e,
  "video-camera": 0xe4da,
  "video-camera-slash": 0xe4dc,
  "warning": 0xe4e0,
  "warning-circle": 0xe4e2,
  "waveform": 0xe802,
  "x": 0xe4f6,
  "x-circle": 0xe4f8,
};
